import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService, UserService } from '@thiememeulenhoff/ng-security';
import { AsyncPipe } from '@angular/common';
import {
  TranslatePipe,
  UnleashContext,
  UnleashService,
} from '@thiememeulenhoff/ng-sdk';
import { catchError, EMPTY, from, switchMap, tap } from 'rxjs';
import { UserInterface } from '@thiememeulenhoff/types';

@Component({
  imports: [RouterModule, AsyncPipe, TranslatePipe],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  readonly #authService = inject(AuthService);

  readonly #userService = inject(UserService);

  readonly #unleashService = inject(UnleashService);

  readonly user$ = this.#userService.user$;

  readonly loginFailed = signal(false);

  readonly loaded = signal(false);

  ngOnInit(): void {
    this.#authService
      .login()
      .pipe(
        catchError(() => {
          this.loginFailed.set(true);
          return EMPTY;
        }),
        switchMap(() => this.#userService.fetchUser()),
        switchMap(() =>
          from(this.#setupUnleashContext(this.#userService.user)),
        ),
        tap(() => this.loaded.set(true)),
      )
      .subscribe();
  }

  async #setupUnleashContext(user: UserInterface | undefined) {
    if (!user) return;

    const nextContext = {
      [UnleashContext.UserReference]: user.identifier,
      [UnleashContext.Cpis]: user.licenses
        .map((license) => license.cpi)
        .join(','),
      ...(user.brin ? { [UnleashContext.BrinCode]: user.brin } : {}),
    };

    await this.#unleashService.addContext(nextContext);

    await this.#unleashService.start();
  }
}
